import BlogCard, { BlogCardStyles } from "@iewcasia/Components/BlogCard";
import { CustomState } from "@iewcasia/Store/Reducers";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (customState: CustomState) => {
    return {
        isLoading: customState.blogList.isLoading,
        posts: customState.blogList.posts || [],
    };
};

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

export interface BlogCategoryListWidgetStyles {
    wrapper?: InjectableCss;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    noPostsText?: TypographyPresentationProps;
    gridContainerWrapper?: InjectableCss;
    gridContainerPosts?: GridContainerProps;
    gridItemPost?: GridItemProps;
    blogCardExtendedStyle?: BlogCardStyles;
}

export const blogCategoryListWidgetStyles: BlogCategoryListWidgetStyles = {
    centeringWrapper: {
        css: css`
            width: 100%;
            height: 300px;
            display: flex;
            align-items: center;
            justify-content: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    noPostsText: {
        size: 24,
        weight: "bold",
        css: css`
            text-align: center;
        `,
    },
    gridContainerPosts: { gap: 20 },
    gridItemPost: { width: [12, 6, 4, 3, 3] },
};

const styles = blogCategoryListWidgetStyles;

const BlogList: FC<Props> = ({ isLoading, posts }) => {
    if (isLoading && !posts.length) {
        return (
            <StyledWrapper {...styles.centeringWrapper}>
                <LoadingSpinner {...styles.spinner} />
            </StyledWrapper>
        );
    }

    if (posts.length === 0) {
        return (
            <StyledWrapper {...styles.centeringWrapper}>
                <Typography {...styles.noPostsText}>{translate("We're sorry, there were no posts found.")}</Typography>
            </StyledWrapper>
        );
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <LoadingOverlay loading={isLoading}>
                <StyledWrapper {...styles.gridContainerWrapper}>
                    <GridContainer {...styles.gridContainerPosts}>
                        {posts.map(post => {
                            const blogLink: any = {
                                id: post.id,
                                parentId: post.parentId,
                                url: post.url,
                            };

                            return (
                                <GridItem {...styles.gridItemPost} key={post.id}>
                                    <BlogCard
                                        blogLink={blogLink}
                                        openNewWindow={false}
                                        extendedStyles={styles.blogCardExtendedStyle}
                                    />
                                </GridItem>
                            );
                        })}
                    </GridContainer>
                </StyledWrapper>
            </LoadingOverlay>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(BlogList) as any,
    definition: {
        displayName: "Category List",
        group: "Verndale Box - Blog" as any,
        icon: "blog",
        allowedContexts: ["BlogCategoryPage" as any],
    },
};

export default widgetModule;
